import { render, staticRenderFns } from "./iframe3D.vue?vue&type=template&id=28c25290&scoped=true"
import script from "./iframe3D.vue?vue&type=script&lang=js"
export * from "./iframe3D.vue?vue&type=script&lang=js"
import style0 from "./iframe3D.vue?vue&type=style&index=0&id=28c25290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c25290",
  null
  
)

export default component.exports